import { PricingConfiguratorService } from './services/PricingConfiguratorService';
import type { Init } from './types';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import { WithApi } from '../WithApi';

export type PricingConfiguratorData = MergedDataReturnType<[PricingConfiguratorService]>;

export type PricingConfiguratorHandlers = MergedHandlersReturnType<[PricingConfiguratorService]>;

type TApi = ReturnType<PricingConfiguratorService['api']>;

export class PricingConfiguratorManager extends WithApi<TApi> {
  public pricingConfiguratorInit = ({ t, isStripe }: Init) => {
    const pricingConfiguratorService = new PricingConfiguratorService(t, isStripe);

    this.initApi({
      ...pricingConfiguratorService.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...pricingConfiguratorService.data(),
      },
      handlers: {
        ...pricingConfiguratorService.handlers(),
      },
    } as const;
  };
}
